import actions from 'src/modules/voting/view/votingViewActions';

const initialData = {
  loading: false,
  record: null,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.FIND_STARTED) {
    return {
      ...state,
      record: null,
      loading: true,
    };
  }

  if (type === actions.FIND_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
    };
  }

  if (type === actions.FIND_ERROR) {
    return {
      ...state,
      record: null,
      loading: false,
    };
  }

  if (type === actions.SIGNIFICANT_VOTE_UPDATE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.SIGNIFICANT_VOTE_UPDATE_SUCCESS) {
    return {
      ...state,
      loading: false,
      record: payload,
    };
  }

  if (type === actions.SIGNIFICANT_VOTE_UPDATE_ERROR) {
    return {
      ...state,
      record: null,
      loading: false,
    };
  }

  return state;
};
